import { Row, Col, Card, Spinner, Table } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import Layout from '../layout/default';
import {
  Media,
  Icon,
  Pureknob
} from '../components';
import { Colors } from '../utilities/index';
import Swal from "sweetalert2"
import instance from "./api"
import { Link } from "react-router-dom"
import UserMap from './UserMap';

function HomeEcommerce() {
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [ latestOrders, setLatestOrders ] = useState([]);
  const [ mostSearchedProduct, setMostSearchedProduct ] = useState([])
  const [ bestSeller, setBestSeller ] = useState([])
  const [userLocations, setUserLocations] = useState([]);
  
//   const dummyUserLocations = [
//     {
//         "name": "Location 1",
//         "coordinates": {
//             "latitude": 17.4482,
//             "longitude": 78.3875
//         }
//     },
//     {
//         "name": "Location 2",
//         "coordinates": {
//             "latitude": 17.4485,
//             "longitude": 78.3890
//         }
//     },
//     {
//         "name": "Location 3",
//         "coordinates": {
//             "latitude": 17.4470,
//             "longitude": 78.3840
//         }
//     },
//     {
//         "name": "Location 4",
//         "coordinates": {
//             "latitude": 17.4490,
//             "longitude": 78.3865
//         }
//     },
//     {
//         "name": "Location 5",
//         "coordinates": {
//             "latitude": 17.4500,
//             "longitude": 78.3880
//         }
//     },
//     {
//         "name": "Location 6",
//         "coordinates": {
//             "latitude": 17.4465,
//             "longitude": 78.3855
//         }
//     },
//     {
//         "name": "Location 7",
//         "coordinates": {
//             "latitude": 17.4488,
//             "longitude": 78.3900
//         }
//     },
//     {
//         "name": "Location 8",
//         "coordinates": {
//             "latitude": 17.4478,
//             "longitude": 78.3868
//         }
//     },
//     {
//         "name": "Location 9",
//         "coordinates": {
//             "latitude": 17.4495,
//             "longitude": 78.3845
//         }
//     },
//     {
//         "name": "Location 10",
//         "coordinates": {
//             "latitude": 17.4503,
//             "longitude": 78.3895
//         }
//     }
// ]

// console.log(userLocations)

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [dashboardResponse, ordersResponse, mostSearchedProductResponse, bestSellerResponse, customerResponse ] = await Promise.all([
          instance.get('api/Dashboard'),
          instance.get('api/Order?pageSize=10&page=0'),
          instance.get('api/Product/list?page_size=5&page=0&most_viewed=1'),
          instance.get('api/Product/list/best_sellers'),
          instance.get('api/Customer'),
        ]);
        setDashboardData(dashboardResponse.data);
        setLatestOrders(ordersResponse.data.orders.rows);
        setMostSearchedProduct(mostSearchedProductResponse.data.rows);
        setBestSeller(bestSellerResponse.data.rows);
        setUserLocations(customerResponse.data.rows);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
        setLoading(false);
        Swal.fire('Error', 'Failed to fetch dashboard data!', 'error');
      }
    };

    fetchData();
  }, []);



  // const downloadInvoice = async (orderId) => {
  //   setLoading(true);
  //   try {
  //     const response = await instance.get(`api/Order/invoice/${orderId}`, {
  //       responseType: 'blob'
  //     });
  //     const fileURL = window.URL.createObjectURL(new Blob([response.data]));
  //     const fileLink = document.createElement('a');
  //     fileLink.href = fileURL;
  //     fileLink.setAttribute('download', `invoice_${orderId}.pdf`);
  //     document.body.appendChild(fileLink);
  //     fileLink.click();
  //     document.body.removeChild(fileLink);
  //   } catch (error) {
  //     console.error("Error downloading invoice:", error);
  //     Swal.fire('Error', 'Failed to download invoice!', 'error');
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  if (loading) {
    return (
      <Layout title="Dashboard">
        <div className="text-center my-4">
          <Spinner animation="border" variant="primary" />
        </div>
      </Layout>
    );
  }
  const formattedPrice = (row) => {
    const formattedPrice = parseFloat(row.total).toFixed(2).replace(/\.00$/, '');
    if (row.currency === "USD") {
      return `$${formattedPrice}`;
    }
    return `Rs.${formattedPrice}`;
  };
  const formatDate = (dateString) => {
    const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-GB', options);
  };

  const viewInvoice = async (orderId) => {
    setLoading(true);
    try {
      const response = await instance.get(`api/Order/invoice/${orderId}`, {
        responseType: 'blob'
      });
      const fileURL = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      window.open(fileURL, '_blank');
    } catch (error) {
      console.error("Error viewing invoice:", error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <Layout title="Dashboard">
      <Row className="g-gs">
        <Col xxl="12">
          <Row className="g-gs">
            <Col sm="6" xl="3" xxl="3">
              <Card className="h-100">
                <Card.Body>
                  <Media shape="circle" variant="warning" className="mb-3">
                    <Icon name="trend-up"></Icon>
                  </Media>
                  <h5>Monthly Sales</h5>
                  <div className="d-flex align-items-center mb-3">
                    <div className="amount h4 mb-0">
                      {parseFloat(dashboardData.salesStatistics.monthlySales)}
                    </div>
                  </div>
                  <p className="small">This Month</p>
                </Card.Body>
              </Card>
            </Col>

            <Col sm="6" xl="3" xxl="3">
              <Card className="h-100">
                <Card.Body>
                  <Media shape="circle" variant="success" className="mb-3">
                    {/* <Icon name="sign-mxn"></Icon> */}
                    {/* <p style={{color:"white", fontSize:"20px", }}>   👥</p> */}
                    <div style={{width:"24px", height:"24px"}}>

                    <img src="/customers.png" alt="Customers Icon" />
                    </div>
                  </Media>
                  <h5>New Customers</h5>
                  <div className="d-flex align-items-center mb-3">
                    <div className="amount h4 mb-0">
                      {dashboardData.customerStatistics.thisMonthCustomerCount}
                    </div>
                  </div>
                  <p className="small">This Month</p>
                </Card.Body>
              </Card>
            </Col>

            <Col sm="6" xl="3" xxl="3">
              <Card className="h-100">
                <Card.Body>
                  <Media shape="circle" variant="success" className="mb-3">
                    <Icon name="coins"></Icon>
                  </Media>
                  <h5>Orders Count</h5>
                  <div className="d-flex align-items-center mb-3">
                    <div className="amount h4 mb-0">
                      {dashboardData.orderStatistics.thisMonthOrdersCount}
                    </div>
                  </div>
                  <p className="small">This Month</p>
                </Card.Body>
              </Card>
            </Col>

            <Col sm="6" xl="3" xxl="3">
              <Card className="h-100">
                <Card.Body className="text-center">
                  <div className="amount h4 mb-0"></div>
                  <Pureknob data={{
                    size: 120,
                    value: dashboardData.orderStatistics.todayOrdersCount,
                    angleOffset: -0.5,
                    angleStart: 0.5,
                    angleEnd: 0.5,
                    colorFg: Colors.info
                  }} className="nk-chart-ecommerce-knob" />
                  <p className="small mt-3">Orders Today</p>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Col>

        <Col xxl="6">
          <Card className="h-100">
            <Row className="g-0 col-sep col-sep-md position-relative">
              <Col md="4">
                <Card.Body>
                  <div className="total-profit-data">
                    <ul className="nk-data-list-group d-flex flex-column flex-sm-row flex-md-column gap g-4">
                      <li className="nk-data-list-item">
                        <Media shape="circle" variant="primary-soft">
                             <p style={{fontSize:'20px'}}>   ₹</p>
                          {/* <Icon name="sign-mxn"></Icon> */}
                          {/* <Icon name="rupee"></Icon> */}
                        </Media>
                        <div className="amount-wrap">
                          <div className="amount h3 mb-0">{dashboardData.salesStatistics.totalSales}</div>
                          <span className="smaller">Total Sales</span>
                        </div>
                      </li>
                      <li className="nk-data-list-item">
                      <Link to="/order-manage/order-list" style={{ textDecoration: 'none', color: 'inherit',display:'flex'  }}>

                        <Media shape="circle" variant="primary-soft">
                          <Icon name="coins"></Icon>
                        </Media>
                        <div className="amount-wrap">
                          <div className="amount h3 mb-0">{dashboardData.orderStatistics.totalOrdersCount}</div>
                          <span className="smaller">Total Orders</span>
                        </div>
                        </Link>
                      </li>
                      <li className="nk-data-list-item">
                      <Link to="/user-manage/user-list" style={{ textDecoration: 'none', color: 'inherit',display:'flex' }}>

                        <Media shape="circle" variant="success-soft">
                          <Icon name="trend-up"></Icon>
                        </Media>
                        <div className="amount-wrap">
                          <div className="amount h3 mb-0">{dashboardData.customerStatistics.totalCustomerCount}</div>
                          <span className="smaller">Total Customers</span>
                        </div>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </Card.Body>
              </Col>
            </Row>
            {/* <div className="position-absolute top-0 end-0 mt-3 me-3">
              <h5 className="me-2 d-inline">Download Invoice</h5>
              <InputGroup className="w-auto d-inline-flex">
                <FormControl
                  placeholder="Enter order ID"
                  value={orderId}
                  onChange={(e) => setOrderId(e.target.value)}
                />
                <Button variant="outline-secondary" onClick={() => downloadInvoice(orderId)}>
                  <Icon name="download"></Icon>
                </Button>
              </InputGroup>
            </div> */}
          </Card>
        </Col>
        
      </Row>
      <Row className="mt-4">
        <Col xxl="6">
          <Card>
            <Card.Header>
              <h5>Most Viewed Products</h5>
            </Card.Header>
            <Card.Body>
              <Table responsive>
                <thead>
                  <tr>
                    <th>Product ID</th>
                    <th>Product Name</th>
                    <th>Price</th>
                    <th>Shelf Life</th>
                    {/* <th>Status</th> */}
                  </tr>
                </thead>
                <tbody>
                  {mostSearchedProduct.map((product) => (
                    <tr key={product.product_id}>
<td onClick={() => {}} style={{ cursor: 'pointer', textDecoration: 'underline' }}>{product.product_id}</td>
                      <td>{product.name}</td>
                      <td>{product.price}</td>
                      <td> { product.shelf_life }</td>
                      {/* <td>{product.status === 1 ? "Available" : "Not Available"}</td> */}
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        </Col>
         <Col xxl="6">
          <Card>
            <Card.Header>
              <h5>Best Selling Products</h5>
            </Card.Header>
            <Card.Body>
              <Table responsive>
                <thead>
                  <tr>
                    <th>Product ID</th>
                    <th>Product Name</th>
                    <th>Price</th>
                    <th>Shelf Life</th>
                    {/* <th>Status</th> */}
                  </tr>
                </thead>
                {/* {
                      "product_id": 296,
                      "total_quantity_sold": "2579",
                      "Product": {
                        "product_id": 296,
                        "category_id": 36,
                        "name": "Ariselu",
                        "model": 5472,
                        "weight": null,
                        "shelf_life": null,
                        "product_retailer_id": null,
                        "quantity": 887,
                        "stock_status_id": 5,
                        "image": "data/36/DSC_5472.jpg",
                        "price": 10,
                        "ind_price": 0,
                        "retailer_id": null,
                        "ind_retailer_id": null,
                        "date_available": "2012-08-12",
                        "status": 1,
                        "viewed": 5523,
                        "sort_order": 1,
                        "createdAt": "2012-08-13T07:07:00.000Z",
                        "updatedAt": "2012-08-29T04:03:00.000Z"
               } */}
                
                <tbody>
                  {bestSeller.slice(0, 5).map((product) => (
                    <tr key={product.product_id}>
<td onClick={() => {}} style={{ cursor: 'pointer', textDecoration: 'underline' }}>{product.product_id}</td>
                      <td>{product.Product?.name}</td>
                      <td>{product.Product?.price}</td>
                      <td> { product.Product?.shelf_life }</td>
                      {/* <td>{product.Product?.status === 1 ? "Available" : "Not Available"}</td> */}
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      

{/* MAP CONTAINER */}
<Row  className="mt-4">
        <Col>
          <Card>
            <Card.Header>
              <h5>User Map</h5>
            </Card.Header>
            <Card.Body>
              <UserMap 
                userLocations={userLocations}
                // userLocations={dummyUserLocations}
              />
            </Card.Body>
            
          </Card>
        </Col>
      </Row>



      <Row className="mt-4">
        <Col>
          <Card>
            <Card.Header>
              <h5>Latest 10 Orders</h5>
            </Card.Header>
            <Card.Body>
              <Table responsive>
                <thead>
                  <tr>
                    <th>Order ID</th>
                    <th>Order Date</th>
                    <th>Customer</th>
                    <th>Total Amount</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {latestOrders.map((order) => (
                    <tr key={order.order_id}>
<td onClick={() => viewInvoice(order.order_id)} style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}>{order.order_id}</td>
                      <td>{formatDate(order.date_added)}</td>
                      <td>{order.firstname} {order.lastname}</td>
                      <td>        <span>{formattedPrice(order)}</span></td>
                      <td>{order.WebtagOrderStatus.name}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Layout>
  )
}

export default HomeEcommerce;
